import { ContainerLargeType } from '../../../molecules/ContainerLarge/ContainerLarge.helpers';
import ContainerLarge from '~/components/molecules/ContainerLarge';
import DescriptionDetail from './DescriptionDetail.JobDetail';

/**
 * @param {DescriptionProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Description = ({ description, alternativeLanguage = '', language }) => {
  return (
    <ContainerLarge
      type={ContainerLargeType.A}
      elements={[
        <>
          {description.map((item, idx) => {
            return (
              <>
                {idx === description.length - 1 ? (
                  <div id="anchorApplyJob" />
                ) : (
                  <></>
                )}
                <DescriptionDetail
                  key={idx}
                  value={item.value}
                  title={item.title}
                  alternativeLanguage={alternativeLanguage}
                  language={language}
                />
              </>
            );
          })}
        </>,
      ]}
    />
  );
};

export default Description;
